import { ShowcasePage } from "@features/shared/showcase";
import { createFileRoute } from "@tanstack/react-router";
import { Palette } from "lucide-react";

/**
 * Design-system showcase route (plan-business-semantic §6, governance 5).
 * Thin route: staticData + component — zero UI logic (frontend AGENTS.md).
 * Access: any authenticated user (inherits the _app login guard).
 */
export const Route = createFileRoute("/_app/design-system/showcase")({
  staticData: {
    title: "Design System",
    section: "Général",
    order: 98,
    showInTab: false,
    showInBreadcrumb: true,
    icon: Palette,
  },
  component: ShowcasePage,
});
